


import { defineComponent, onMounted, ref, onBeforeUnmount, computed, onUnmounted } from 'vue';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import SplitButtonTypeConst from '../../../../domain/Constants/SplitButtonTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import CatalogEventConst from '../../../../../catalog/domain/const/CatalogEventConst';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';

export default defineComponent({
    name: 'dynamic_split_button',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        const store = useStore();
        const router = useRouter();
        const {getLayoutComponent,buildMenu, vmodel,baseOnMounted, isValidData, getPropertyValue, getPropertyBooleanValue, loaded, componentData, resolveExpressions, getCatalogValue, baseOnUnmount,fieldKey,fieldKeyComponentDataSourceId,processEventComponent } = ComponentCommon(props, context,store);


        const menuItems = ref([])
        const layoutMenu = getLayoutComponent(props.Component, SplitButtonTypeConst.LAYOUT_SPLITBTN_MENU);
        if (layoutMenu && layoutMenu?.children?.length > 0) {
            menuItems.value = buildMenu(layoutMenu?.children[0].children ?? []) as any;          
        }


        onMounted(() => {
            baseOnMounted();
           
        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {            
            getPropertyValue,
            getPropertyBooleanValue,
            SplitButtonTypeConst,
            loaded,
            BaseControlTypeConst,
            processEventComponent,
            CatalogEventConst,
            getCatalogValue,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId,
            menuItems

        };
    },
});
